import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-854c1360"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sbp-panel" }
const _hoisted_2 = { class: "sbp-panel__total" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, " Итого к оплате: ", -1))
const _hoisted_4 = { class: "price rouble-symbol" }
const _hoisted_5 = {
  key: 0,
  class: "sbp-panel__qr-block qr-block"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qr-block__title" }, " Отсканируйте QR-код для оплаты ", -1))
const _hoisted_7 = {
  key: 0,
  class: "qr-block__code-image"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "qr-block__preloader"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"qr-block__description\" data-v-854c1360> Как платить через СБП <div class=\"qr-block__info-icon\" data-v-854c1360><div class=\"sbp-panel__tooltip-wrapper tooltip-wrapper\" data-v-854c1360><div class=\"tooltip\" data-v-854c1360><ol data-v-854c1360><li data-v-854c1360>Отсканируйте QR-код камерой или приложением своего банка</li><li data-v-854c1360>Подтвердите оплату в приложении банка</li></ol><div class=\"tooltip__description\" data-v-854c1360> (если вы отсканировали QR камерой, выберите приложение банка и перейдите к оплате.) </div></div></div></div></div>", 1)
const _hoisted_11 = { class: "qr-block__timer" }
const _hoisted_12 = {
  key: 1,
  class: "sbp-panel__timeout"
}
const _hoisted_13 = { class: "sbp-panel__error-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.totalPrice)), 1)
    ]),
    (!_ctx.errorText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: `data:image/png;base64, ${_ctx.qrCodeImg}`
                }, null, 8, _hoisted_8)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_Loading, {
                  active: _ctx.isLoading,
                  "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event))
                }, null, 8, ["active"])
              ])),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, " Осталось: " + _toDisplayString(_ctx.getFormatTime(_ctx.timeLeft)), 1),
          _createElementVNode("button", {
            class: "sbp-panel__btn sbp-panel__btn--sbp-process base-btn base-btn--black",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('process')))
          }, " Оплатить ")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.errorText), 1),
          _createElementVNode("button", {
            class: "sbp-panel__btn base-btn base-btn--black",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('retry')))
          }, " Попробовать еще раз ")
        ])),
    _createElementVNode("div", {
      class: "sbp-panel__close",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
    })
  ]))
}